import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import BarsOutlinedSvg from "@ant-design/icons-svg/es/asn/BarsOutlined";
import AntdIcon from "../components/AntdIcon";
var BarsOutlined = function BarsOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BarsOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(BarsOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'BarsOutlined';
}
export default RefIcon;